import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import "./styles.css";

// Shared hero banner for Destinations (/:slug) and SearchAndFilter (/main).
// `showBack` lets a page that already renders its own Back control suppress the
// overlaid one (Destinations does) — optional, defaults to true so SearchAndFilter
// keeps its only Back affordance.
export default function HeaderImage({ image, showBack = true }) {
  return (
    <Box
      className="header-banner"
      sx={{
        position: "relative",
        display: "flex",
        width: "100%",
        height: "clamp(220px, 45vh, 420px)",
        bgcolor: "action.hover",
        backgroundImage: image ? `url(${image})` : "none",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      {showBack && (
        <Button
          component={Link}
          to="/"
          variant="contained"
          startIcon={<ChevronLeftIcon />}
          sx={{
            position: "absolute",
            top: (theme) => theme.spacing(2),
            left: (theme) => theme.spacing(2),
          }}
        >
          Back
        </Button>
      )}
    </Box>
  );
}
